module.exports = __webpack_public_path__ + "static/media/month.4cb27b46.svg";